import { FC } from "react";

const Footer: FC = () => {
  return (
    <footer className="py-6 px-12 lg:px-14 font-semibold text-secondary bg-footer-bg bg-cover bg-top">
      <div className="container mx-auto flex items-center justify-between xs:justify-evenly">
        <p className="text-center lg:text-lg lg:whitespace-nowrap">
          Copyright © 2025 Klub českých turistů. Created by ITIXO s.r.o.
        </p>
        <a
          href="https://www.facebook.com/events/2112383962550664/?acontext=%7B%22event_action_history%22%3A[]%7D&locale=cs_CZ"
          target="_blank"
          rel="noopener noreferrer"
          className="flex"
        >
          <img
            src="/images/facebook-icon.svg"
            alt="Facebook KČT"
            className="xs:w-10 xs:h-10 hover:opacity-60 transition-opacity"
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
